<template>
  <div class="mutil-type-wrapper">
    <div v-if="hasIcon" :class="['mutil-type-hasIcon', { 'is-detail': isDetail }, { 'is-two': !isDetail && quesData.memberAnswerList.length === 2 }]">
      <template v-for="(item, key) in quesData.memberAnswerList">
        <div v-if="isDetail && item.memberOptionSelected" :key="key" class="mutil-item-detail">
          <div class="label">{{ item.optionTitle }}</div>
        </div>
        <div
          v-else-if="!isDetail"
          :key="key"
          :class="['mutil-item', { 'is-active': quesData.value && (quesData.value.indexOf(item.answerId) > -1) }]"
          @click="chooseItem(item)">
          <img :src="item.optionIconUrl" />
          <div class="label">{{ item.optionTitle }}</div>
        </div>
      </template>
    </div>
    <div v-else class="mutil-type">
      <van-checkbox-group v-model="quesData.value">
        <template v-for="(item, key) in quesData.memberAnswerList">
          <van-checkbox v-if="!isDetail || (isDetail && item.memberOptionSelected)" :key="key" :name="item.answerId" icon-size="18px" class="mutil-item">
            <template #icon="props">
              <img v-if="props.checked" class="img-icon" src="../../../../assets/crf/mutil-checked.svg" />
              <img v-else class="img-icon" src="../../../../assets/crf/unchecked.svg" />
            </template>
            {{ item.optionTitle }}
          </van-checkbox>
        </template>
      </van-checkbox-group>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'MutilType',
  props: {
    questionData: {
      type: Object,
      default() {}
    },
    isDetail: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      quesData: this.questionData,
    };
  },
  created() {
    if (this.isDetail) {
      const chosenList = _.filter(this.questionData.memberAnswerList, { memberOptionSelected: 1 }) || null;
      this.quesData.value = chosenList?.map(item => item.answerId) || [];
    }
  },
  watch: {
    'quesData.value'(val) {
      const memberAnswerList = this.questionData.memberAnswerList?.map(item => {
        return {
          ...item, 
          memberOptionSelected: val?.indexOf(item.answerId) > -1 ? 1 : 0
        }
      });
      this.$set(this.quesData, 'memberAnswerList', memberAnswerList);
    }
  },
  computed: {
    hasIcon() {
      return _.filter(this.quesData.memberAnswerList, item => !!item.optionIconUrl)?.length > 0;
    }
  },
  methods: {
    chooseItem(item) {
      const arr = this.quesData.value || [];
      const index = this.quesData.value?.indexOf(item.answerId);
      if (index > -1) {
        arr.splice(index, 1);
      } else {
        arr.push(item.answerId);
      }
      this.$set(this.quesData, 'value', arr);
    }
  }
}
</script>

<style lang="scss" scoped>
.mutil-type-wrapper {
  margin-top: 24px;
  :deep(.van-checkbox__icon--checked+.van-checkbox__label) {
    font-weight: 500;
  }
  .mutil-type-hasIcon {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    gap: 26px;
    &.is-detail {
      justify-content: flex-start;
      margin-top: 16px;
    }
    &.is-two {
      justify-content: center;
      gap: 130px;
    }
    .mutil-item-detail {
      background: #FFEEEB;
      border-radius: 38px;
      display: flex;
      align-items: center;
      padding: 10px 40px;
      font-weight: 500;
      font-size: 28px;
      img {
        width: 48px;
        height: 48px;
        margin-right: 22px;
      }
    }
    .mutil-item {
      width: 210px;
      border: 2px solid #E5E5E5;
      border-radius: 16px;
      background: #F8F8F8;
      text-align: center;
      box-sizing: border-box;
      flex: none;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: space-between;
      &.is-active {
        border: 2px solid #FF583E;
        background: #FFEEEB;
      }
      img {
        width: 100%;
      }
      .label {
        font-weight: 500;
        font-size: 28px;
        color: #3A3B3C;
        margin: 16px;
        word-wrap: break-word;
      }
    }
  }
  .mutil-type {
    .mutil-item {
      margin-top: 36px;
      align-items: flex-start;
      &:nth-child(1) {
        margin-top: 0;
      }
    }
    .img-icon {
      margin-top: 2px;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
